import { render, staticRenderFns } from "./Table361GeneralCheckup.vue?vue&type=template&id=ad71bcda&scoped=true"
import script from "./Table361GeneralCheckup.vue?vue&type=script&lang=js"
export * from "./Table361GeneralCheckup.vue?vue&type=script&lang=js"
import style0 from "./Table361GeneralCheckup.vue?vue&type=style&index=0&id=ad71bcda&prod&lang=css"
import style1 from "./Table361GeneralCheckup.vue?vue&type=style&index=1&id=ad71bcda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad71bcda",
  null
  
)

export default component.exports